export const customCalculatorDropdownStyles = {
  control: (provided, state) => ({
    ...provided,
    padding: "0",
    boxShadow: state.isFocused ? "0 0 0 2px rgba(202,0,0,0.15)" : "none",
    borderColor: state.isFocused ? "#CA0000" : provided.borderColor || "#D1D5DB",
    transition: "border-color 150ms ease, box-shadow 150ms ease",
    height: "28px",
    minHeight: "28px",
    fontSize: "12px",
    backgroundColor: "#fff",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    width: "100px",     
    minWidth: "120px", 
    maxWidth: "160px", 
  }),
  indicatorSeparator: () => ({ display: "none" }),
  indicatorsContainer: (provided) => ({
    ...provided,
    padding: "0 6px 0 2px",
    margin: 0,
    height: "28px",
    minHeight: "28px",
    display: "flex",
    alignItems: "center",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: 0,
    margin: 0,
    height: "12px",
    width: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }),
  singleValue: (provided) => ({
    ...provided,
    padding: 0,
    margin: 0,
    textAlign: "left",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    height: "28px",
    lineHeight: "28px",
    fontSize: "12px",
    color: "#111827",
  }),
  placeholder: (provided) => ({
    ...provided,
    padding: 0,
    margin: 0,
    textAlign: "left",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    height: "28px",
    lineHeight: "28px",
    fontSize: "12px",
    color: "#6B7280",
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: "0 8px",
    margin: 0,
    height: "28px",
    minHeight: "28px",
    fontSize: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  }),
  input: (provided) => ({
    ...provided,
    padding: 0,
    margin: 0,
    textAlign: "left",
    height: "28px",
    lineHeight: "28px",
    fontSize: "12px",
  }),
  option: (provided, state) => ({
    ...provided,
    padding: "8px 10px",
    margin: 0,
    textAlign: "left",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#111827",
    backgroundColor: state.isSelected ? "#E5E7EB" : state.isFocused ? "#F3F4F6" : "#fff",
    cursor: "pointer",
    width: "140px",     
    minWidth: "150px", 
    maxWidth: "200px", 
  }),
  menu: (provided) => ({
    ...provided,
    padding: "4px 0",
    zIndex: 10,
    borderRadius: "8px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.08), 0 2px 6px rgba(0,0,0,0.05)",
    overflow: "hidden",
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0,
    margin: 0,
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 10,
  }),
};
